import { useState } from "react";
import { Link } from "react-router-dom";

export function saveConsent(c) {
  localStorage.setItem("om_consent", JSON.stringify({ ...c, decided: true, at: new Date().toISOString() }));
}

export default function ConsentBanner() {
  const [open, setOpen] = useState(() => !JSON.parse(localStorage.getItem("om_consent") || "{}").decided);
  if (!open) return null;
  const decide = (analytics, marketing) => { saveConsent({ analytics, marketing }); setOpen(false); };
  return (
    <div data-testid="consent-banner" className="fixed bottom-4 left-4 right-4 md:left-auto md:w-[420px] z-50 bg-[#14161D] border border-white/10 p-6 rise">
      <div className="label-xs mb-2">Confidentialité</div>
      <p className="text-sm text-muted-foreground">Nous utilisons des cookies strictement nécessaires (session, panier). Les mesures d'audience et le marketing ne sont activés qu'avec votre accord. <Link to="/legal/consentement" className="underline">Personnaliser</Link></p>
      <div className="flex gap-2 mt-4">
        <button data-testid="consent-accept" onClick={() => decide(true, true)} className="flex-1 bg-[#C9A96E] text-black text-sm font-semibold py-2 hover:bg-[#E5C384] transition-colors">Tout accepter</button>
        <button data-testid="consent-reject" onClick={() => decide(false, false)} className="flex-1 border border-white/15 text-sm py-2 hover:bg-white/5 transition-colors">Tout refuser</button>
      </div>
    </div>
  );
}
